module.exports = __webpack_public_path__ + "static/media/footer-shibani.6c9910b5.png";